import { Grid } from '@material-ui/core'

interface ContentProps {
    lang: string
}
const Content = ({ lang }: ContentProps) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: lang === 'th' ? window.acceptanceContentTH : window.acceptanceContentEN,
                    }}
                ></div>
            </Grid>
        </Grid>
    )
}

export default Content
